module.exports = __webpack_public_path__ + "kz.jpg?f931f1cb6cbfeadc242b4a023b99509e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kz.jpg
// module id = 88
// module chunks = 0